import { render, staticRenderFns } from "./DsarPerReceivingMeans.vue?vue&type=template&id=4f5c2cc6&"
import script from "./DsarPerReceivingMeans.vue?vue&type=script&lang=js&"
export * from "./DsarPerReceivingMeans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports